<template>
  <div class="drivers">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>

    <div class="col-12 text-left">
      <h1>{{ title }}</h1>
      <h6 class="text-danger" v-if="non_field_errors">{{ non_field_errors }}</h6>
    </div>

    <div class="row">
      <div class="col-md-3 col-lg-2 m-0 p-0">
        <label class="search-label">Driver ID</label>
        <input type="text" placeholder="id_driver" v-model="id_driver"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.id_driver }}</div>
      </div>

      <!--<div class="col-md-10 col-lg-10 m-0 p-0"></div>-->

      <div class="col-md-4 col-lg-3 m-0 p-0">
        <label class="search-label">Vehicle Year</label>
        <input type="text" placeholder="year" v-model="year"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.year }}</div>
      </div>
      <div class="col-md-4 col-lg-3 m-0 p-0 form-ddown ">
        <label class="search-label">Vehicle Make</label>
        <select type="text" placeholder="id_make_vehicle" v-model="id_make_vehicle"
               class="form-control ddown">
          <option v-for="(item, key) in make_vehicles" :value="item.id_make_vehicle">
            {{item.name}}
          </option>
        </select>
        <div v-if="errors" class="text-danger">{{ errors.id_make_vehicle }}</div>
      </div>
      <div class="col-md-5 col-lg-3 m-0 p-0">
        <label class="search-label">Vehicle Model</label>
        <input type="text" placeholder="model" v-model="model"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.model }}</div>
      </div>
      <div class="col-md-3 col-lg-2 m-0 p-0 form-ddown">
        <label class="search-label">Vehicle Size</label>
        <select type="text" placeholder="id_type_vehicle" v-model="id_type_vehicle"
                class="form-control ddown">
          <option v-for="(item, key) in type_vehicles" :value="item.id_type_vehicle">
            {{item.code}}
          </option>
        </select>
        <div v-if="errors" class="text-danger">{{ errors.id_type_vehicle }}</div>
      </div>
      <div class="col-md-3 col-lg-2 m-0 p-0">
        <label class="search-label">License Plate Number</label>
        <input type="text" placeholder="license_plate_number" v-model="license_plate_number"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.license_plate_number }}</div>
      </div>
      <div class="col-md-3 col-lg-2 m-0 p-0">
        <label class="search-label">Vehicle Identification Number</label>
        <input type="text" placeholder="VIN" v-model="VIN"
               class="form-control"/>
        <div v-if="errors" class="text-danger">{{ errors.vin }}</div>
      </div>

      <div class="col-md-4 col-lg-1 m-0 p-0"></div>

      <div class="col-md-4 col-lg-3 m-0 p-0">
        <label class="search-label">Vehicle Picture</label>
        <input type="file" id="id_image" ref="id_image" v-on:change="handleFileUpload(source='id_image')"/>
        <img v-if="vehicle_picture_url" style="width: 100%;"
             :src="vehicle_picture_url">
        <div v-if="errors" class="text-danger">{{ errors.id_image }}</div>
      </div>
      <div class="col-md-4 col-lg-3 m-0 p-0 form-ddown">
        <label class="search-label">Vehicle Inspection Date</label>
        <VueCtkDateTimePicker v-model="vehicle_inspection_date" format="YYYY-MM-DD HH:mm:ss"
                              label="Inspection Date"/>
        <div v-if="errors" class="text-danger">{{ errors.vehicle_inspection_date }}</div>
      </div>

      <div class="col-md-2 col-lg-0 m-0 p-0"></div>

      <div class="col-md-2 col-lg-2 m-0 p-0">
        <label class="search-label">Vehicle Inspection Picture</label>
        <input type="file" id="id_vehicle_inspection_image" ref="id_vehicle_inspection_image"
               v-on:change="handleFileUpload(source='id_vehicle_inspection_image')"/>
        <img v-if="id_vehicle_inspection_image_url" style="width: 100%;"
             :src="id_vehicle_inspection_image_url">
        <div v-if="errors" class="text-danger">{{ errors.id_vehicle_inspection_image }}</div>
      </div>
    </div>

    <div class="submit-button">
      <button v-on:click="buttonCreate()" class="btn btn-primary btn-sm" style="width:100%">Create</button>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    name: 'CreateVehicle',
    data () {
      return {
        title: 'Create a Vehicle',
        isLoading: false,
        errors: null,
        non_field_errors: null,
        id_driver: 1,
        license_plate_number: 'che4314',
        VIN: '2c4rdgeg3gr313490',
        year: 2016,
        model: 'Caravan/Grand Caravan R/T',
        id_make_vehicle: 4,
        id_type_vehicle: 1,
        id_image: null,
        vehicle_inspection_date: null,
        id_vehicle_inspection_image: null,
        description: 'This is a beautiful car.',
        vehicle_picture_url: null,
        id_vehicle_inspection_image_url: null,
        make_vehicles: null,
        type_vehicles: null
      }
    },
    components: {
      Loading
    },
    methods: {
      buttonCreate: function () {
        this.reset()
        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL_CS + 'vehicles/', {
            id_driver: this.id_driver,
            license_plate_number: this.license_plate_number,
            vin: this.VIN,
            year: this.year,
            model: this.model,
            id_make_vehicle: this.id_make_vehicle,
            id_type_vehicle: this.id_type_vehicle,
            id_image: this.id_image,
            vehicle_inspection_date: this.vehicle_inspection_date,
            id_vehicle_inspection_image: this.id_vehicle_inspection_image
          })
          .then(response => {
            Vue.toasted.show('Success!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(response.data)
            this.id_ride = response.data.id_ride
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getMakeVehicles: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'make-vehicles/')
          .then(response => {
            console.log(response.data)
            this.make_vehicles = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      getTypeVehicles: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'type-vehicles/')
          .then(response => {
            console.log(response.data)
            this.type_vehicles = response.data
          })
          .catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
            Vue.toasted.show('Something went wrong!', {
              theme: 'bubble',
              position: 'top-right',
              duration: 2000
            })
            console.log(error.response)
            this.errors = error.response.data
            this.non_field_errors = error.response.data.non_field_errors
          })
          .finally(() => {
            this.isLoading = false
          })
      },
      reset: function () {
        this.errors = null
        this.non_field_errors = null
        this.id_ride = null
      },
      handleFileUpload (source) {
        this.isLoading = true
        console.log('file')
        let file = this.$refs.id_image.files[0]

        if ('id_vehicle_inspection_image' == source) {
          file = this.$refs.id_vehicle_inspection_image.files[0]
        }

        let formData = new FormData()
        formData.append('file', file)

        this.$http.post(process.env.API_BASE_URL_CS + 'images/',
          formData
        ).then(response => {
          Vue.toasted.show('Success!', {
            theme: 'bubble',
            position: 'top-right',
            duration: 2000
          })
          console.log(response.data)

          if ('id_image' == source) {
            console.log('is id_image')
            this.vehicle_picture_url = response.data.url
            this.id_image = response.data.id_image
          } else if ('id_vehicle_inspection_image' == source) {
            this.id_vehicle_inspection_image_url = response.data.url
            this.id_vehicle_inspection_image = response.data.id_image
          }
        }).catch(error => {
            this.check403(error);
            if (error.response.status == 401) {
              console.warn("redirect to login")
              this.handle401()
            }
          Vue.toasted.show('Something went wrong!', {
            theme: 'bubble',
            position: 'top-right',
            duration: 2000
          })
          console.log(error.response)
          this.errors = error.response.data
          this.non_field_errors = error.response.data.non_field_errors
        })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    mounted () {
      this.getMakeVehicles()
      this.getTypeVehicles()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    /*position: fixed;*/
    /*bottom: 60px;*/
    /*right: 50%;*/
    margin-top: 20px;
  }


</style>



// WEBPACK FOOTER //
// src/components/CreateVehicle.vue